module.exports = __webpack_public_path__ + "static/media/KOM_01.5e74b9fe.png";